import { render, staticRenderFns } from "./WildcardUsedModal.vue?vue&type=template&id=0b94c928"
import script from "./WildcardUsedModal.vue?vue&type=script&lang=js"
export * from "./WildcardUsedModal.vue?vue&type=script&lang=js"
import style0 from "./WildcardUsedModal.vue?vue&type=style&index=0&id=0b94c928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports